import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService, LocalStorageService } from '@app/core';
import { SURVEY_CONDITIONAL_MESSAGES } from '@app/shared';
import { of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MockAPIInterceptor implements HttpInterceptor {

    constructor(
        private readonly _commonS: CommonService, 
        private readonly _localS: LocalStorageService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const { body, url, method } = req;
        
        if (url.includes('mock_api')) {
            this._commonS.setLoading(true);

            /** SURVEY QUESTIONS CONDITIONAL LOGIC MOCK APIS STARTS */
            if (url.includes('surveyquestion_v2') && method == 'GET') {
                return this.getSurveyV2Questions();
            }
    
            if (url.includes('surveyquestion_v2') && method == 'POST') {
                return this.saveQuestions(body);
            }
            /** SURVEY QUESTIONS CONDITIONAL LOGIC MOCK APIS ENDS */
        }


        return next.handle(req);
    }

    getSurveyV2Questions() {
        const questionsData = this._localS.getItem('surveyV2Questions');
        const response = {
            data: questionsData || null,
            message: SURVEY_CONDITIONAL_MESSAGES.FETCH_SUCCESS
        };
        
        return of(new HttpResponse({ status: 200, body: response }))
            .pipe(delay(2000), tap(res => this._commonS.setLoading(false)));
    }

    saveQuestions(body: any) {
        this._localS.setItem('surveyV2Questions', body);

        return of(new HttpResponse({ status: 200, body: {
            message: SURVEY_CONDITIONAL_MESSAGES.SAVE_SUCCESS
        }})).pipe(delay(2000), tap(res => this._commonS.setLoading(false)));
    }


}
